import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Box, Button } from '@mui/material';
import { OverlayContext } from 'contextProviders/OverlayContext';
import { PricelistApis } from 'hooks/apis/PricelistApis';
import { exportAnalysisToFile } from 'utils/exportAnalysisUtil';
import { IAnalysisDetail } from 'interfaces/Pricelist/IAnalysisDetail';
import { IPricelistMasterDetailProps } from 'interfaces/Pricelist/IPricelistMasterDetailProps';
import { useErrorSnackbar } from 'hooks/useErrorSnackbar';
import './AnalysisInfo.scss';

const AnalysisInfo = (props: IPricelistMasterDetailProps) => {
  const { setShowLoadingOverlay } = useContext(OverlayContext);
  const showError = useErrorSnackbar();
  const { getAnalysisInfo, getAnalysisExcelDownload } = PricelistApis();
  const [error, setError] = useState('');
  const [analysisInfo, setAnalysisInfo] = useState<IAnalysisDetail | undefined>();

  useEffect(() => {
    getAnalysisInfo(props.analysis, props.matrix)
      .then((data) => {
        if (data?.message) {
          setError(data?.message);
        } else {
          setAnalysisInfo(data);
        }
      })
      .catch((e) => setError(e));
  }, [props, getAnalysisInfo]);

  const exportAnalysis = useCallback(() => {
    if (!analysisInfo) {
      return;
    }

    exportAnalysisToFile({
      analysis: analysisInfo.Analysis,
      matrix: analysisInfo.Matrix,
      setShowLoadingOverlay,
      setDownloadErrorSnackbar: showError,
      getAnalysisExcelDownload
    });
  }, [analysisInfo, showError, setShowLoadingOverlay, getAnalysisExcelDownload]);

  return (
    <Box className="analysisInfo">
      {error && !analysisInfo ? <Box className="errorBox">{error}</Box> : null}
      {!error && !analysisInfo ? <Box><h2>Loading Analysis Info...</h2></Box> : null}
      {analysisInfo ?
        <>
          {analysisInfo.IsTracking ? (
            <Box>
              <h2>Analysis Performed by</h2>
              <p>{analysisInfo.Facility}</p>
            </Box>
          ) : (
            <>
              <Box>
                <h2>Container</h2>
                <p>{analysisInfo.Container}</p>

                <h2>Holding Time</h2>
                <p>{analysisInfo.HoldingTime ? `${analysisInfo.HoldingTime} days` : 'N/A'}</p>

                <h2>Analysis Performed by</h2>
                <p>{analysisInfo.Facility}</p>
              </Box>

              <Box>
                <h2>Method Id</h2>
                <p>{analysisInfo.MethodId}</p>

                <h2>Reference Method</h2>
                <p>{analysisInfo.ReferenceMethod !== '*** DEFAULT SPECIFIC METHOD ***' ? analysisInfo.ReferenceMethod : ''}</p>

                <h2>Analytical Technique</h2>
                <p>{analysisInfo.AnalyticalTechnique}</p>
              </Box>
            </>
          )}
          {analysisInfo.EntryInfo?.length > 0 ? (
            <Box>
              <h2>Additional Information</h2>
              {analysisInfo.EntryInfo.map((m) => (
                <p key={m.EntryInfo}>{m.EntryInfo}</p>
              ))}
            </Box>
          ) : null}
        </> : null}

      <Box>
        <Button className="btnAnalysisExport" onClick={exportAnalysis}>Export Analytes</Button>
      </Box>
    </Box>
  );
};

export default React.memo(AnalysisInfo);
